<template>
  <div class="flex flex-col items-center justify-center min-h-screen">
    <component :is="svgComponent[route.name]?.svg" class="w-full max-w-2xl"></component>
    <div class="mt-6 flex flex-col items-center">
      <at-alert v-if="error" type="danger">{{ error }}</at-alert>
      <h4 v-else class="mb-1 text-xl font-medium text-primary">{{ svgComponent[route.name]?.title }}</h4>
    </div>
    <at-button color="primary" class="mt-8" @click="router.push('/')">{{
      $t('pages.errorPage.goToMainPage')
    }}</at-button>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useMainStore } from '@/to-fsd/shared/store/main';
  import { useI18n } from 'vue-i18n';
  import { AtAlert, AtButton } from '@packages/aliftech-ui';
  import SvgNotAllowed from './SvgNotAllowed.vue';
  import SvgServerError from './SvgServerError.vue';
  import SvgNotFound from './SvgNotFound.vue';
  import { ROUTE_NAMES } from '@/to-fsd/shared/constants';

  const route = useRoute();
  const router = useRouter();
  const { t, locale } = useI18n();
  const store = useMainStore();
  const error = computed(() => {
    return store.error?.lang?.[locale] || store.error?.message;
  });
  const svgComponent = computed(() => ({
    [ROUTE_NAMES.pageNotFound]: {
      svg: SvgNotFound,
      title: t('pages.errorPage.messages.pageNotFound'),
    },
    [ROUTE_NAMES.objectNotFound]: {
      svg: SvgNotFound,
      title: t('pages.errorPage.messages.objectNotFound'),
    },
    [ROUTE_NAMES.noPermission]: {
      svg: SvgNotAllowed,
      title: t('pages.errorPage.messages.notAllowed'),
    },
    [ROUTE_NAMES.moduleAccessDenied]: {
      svg: SvgNotAllowed,
      title: t('pages.errorPage.messages.moduleAccessDenied'),
    },
    [ROUTE_NAMES.serverError]: {
      svg: SvgServerError,
      title: t('pages.errorPage.messages.serverError'),
    },
  }));
</script>
